import { Component, Input } from '@angular/core';
import { BotaoBase } from '@smdapp/ng-shared/components/botoes/botao-base';
@Component({
   selector: 'app-botao-acessar',
   template: `<button [disabled]="desabilitado" class="btn btn-success" (click)="onClique($event)">Acessar</button>`
 })
 export class BotaoAcessarComponent extends BotaoBase
 {
    private _desabilitado: boolean;

    @Input() set desabilitado(desabilitado: boolean) 
    {
       this._desabilitado = desabilitado;
    }
    get desabilitado(): boolean { return this._desabilitado; }

 }